import React, { FC } from "react";
import { SettingsEndpoint } from "../../store/endpoints";
import { useStore } from "effector-react";

interface Props {
  imgClass?: string;
}
const Logo: FC<Props> = ({ imgClass }) => {
  const { data: settings } = useStore(SettingsEndpoint.store);

  if (!settings?.logo) return null;

  if (settings.website_url) {
    return (
      <a
        href={settings.website_url}
        style={{ height: "100%" }}
        target={"_blank"}
        rel={"noreferrer"}
      >
        <img
          className={imgClass}
          src={settings.logo}
          alt={settings.contact_url ?? ""}
          title={settings.website_url ?? ""}
        />
      </a>
    );
  }
  return (
    <img
      className={imgClass}
      src={settings.logo}
      alt={settings.contact_url ?? ""}
      title={settings.website_url ?? ""}
    />
  );
};

export default Logo;
